import { render, staticRenderFns } from "./CreateNewEventPopup.vue?vue&type=template&id=0a1f4a80&scoped=true"
import script from "./CreateNewEventPopup.vue?vue&type=script&lang=ts"
export * from "./CreateNewEventPopup.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewEventPopup.vue?vue&type=style&index=0&id=0a1f4a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f4a80",
  null
  
)

export default component.exports